import {
	backgroundHeader,
	backgroundHeaderMobile,
	widthLogoDesktop,
	widthLogoMobile,
	colorBtnAddSubscriberBtnBackFormButton,
	backgroundBtnFowardFormButton,
	borderBtnBackFormButton,
	backgroundBtnAddSubscriberFormButton,
	colorBtnAddSubscriberkFormButton,
	colorBtnAdvanceFormButton,
	borderBtnAdvanceFormButton,
	backgroundBtnAdvanceFormButton,
	colorTdOrderResume,
	colorH2H4AnchorIconContainerOrderResume,
	borderOrderResume,
	textSpanTimeLine,
	borderTitularDepende,
	colorTitleListSubscribers,
	colorListSubscribersFaRegEdit,
	colorTitleSubscriber,
	colorTitlePayment,
	backgroundNavActivePayment,
	backgroundApplyButtonOrderResume,
	backgroundContainer,
	colorBackgroundChecked
} from './variables';

export const demonstrationDrConsultaTheme = {
	//Header
	backgroundHeaderMobile: backgroundHeaderMobile,
	backgroundHeader: backgroundHeader,
	widthLogoDesktop: widthLogoDesktop,
	widthLogoMobile: widthLogoMobile,
	// Form Button
	colorBtnAddSubscriberBtnBackFormButton: colorBtnAddSubscriberBtnBackFormButton,
	backgroundBtnFowardFormButton: backgroundBtnFowardFormButton,
	borderBtnBackFormButton: borderBtnBackFormButton,
	backgroundBtnAddSubscriberFormButton: backgroundBtnAddSubscriberFormButton,
	colorBtnAddSubscriberkFormButton: colorBtnAddSubscriberkFormButton,
	colorBtnAdvanceFormButton: colorBtnAdvanceFormButton,
	borderBtnAdvanceFormButton: borderBtnAdvanceFormButton,
	backgroundBtnAdvanceFormButton: backgroundBtnAdvanceFormButton,
	colorBackgroundChecked: colorBackgroundChecked,
	// Order Resume
	colorTdOrderResume: colorTdOrderResume,
	colorH2H4AnchorIconContainerOrderResume: colorH2H4AnchorIconContainerOrderResume,
	borderOrderResume: borderOrderResume,
	backgroundApplyButtonOrderResume: backgroundApplyButtonOrderResume,
	// StepCounter (progress bar)
	textSpanTimeLine: textSpanTimeLine,
	// Form Wrapper
	borderTitularDepende: borderTitularDepende,
	// Subscriber Title
	colorTitleSubscriber: colorTitleSubscriber,
	// Subscribers list Title
	colorTitleListSubscribers: colorTitleListSubscribers,
	// Subscribers list
	colorListSubscribersFaRegEdit: colorListSubscribersFaRegEdit,
	// Payment Title
	colorTitlePayment: colorTitlePayment,
	// Payment Nav-tab
	backgroundNavActivePayment: backgroundNavActivePayment,
	//Container
	backgroundContainer: backgroundContainer
};
